import React, { useState, useEffect } from "react";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import PageSerch from "../SerchDocters/Components/PageSerch";
import { useCurrency } from "../../../context/CurrencyContext";
import { getCurrencySymbol } from "../../../services/apiService";
import "./Shop.css";



const Shop = () => {
    // Fallback images in case external images fail to load
    const fallbackImages = [
        "https://via.placeholder.com/300x300/4CAF50/FFFFFF?text=Medical+Equipment",
        "https://via.placeholder.com/300x300/2196F3/FFFFFF?text=Health+Monitor",
        "https://via.placeholder.com/300x300/FF9800/FFFFFF?text=Medical+Device",
        "https://via.placeholder.com/300x300/9C27B0/FFFFFF?text=Health+Care",
        "https://via.placeholder.com/300x300/F44336/FFFFFF?text=Emergency+Kit"
    ];

    const { selectedCurrency, formatPrice, convertPrice, isLoading: currencyLoading } = useCurrency();
    const [displayPrices, setDisplayPrices] = useState({});

    const getDisplayPrice = async (price, baseCurrency) => {
        if (baseCurrency === selectedCurrency) {
          return price;
        }
    
        try {
          const convertedAmount = await convertPrice(price, baseCurrency, selectedCurrency);
          return convertedAmount;
        } catch (error) {
          console.error('Price conversion failed:', error);
          return price;
        }
      };

    



    // Sample product data with better images
    const [products, setProducts] = useState([
        {
            id: 1,
            baseCurrency: "USD",
            name: "Medical Stethoscope",
            price: 89.99,
            originalPrice: 120.00,
            image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=300&h=300&fit=crop&crop=center",
            category: "Medical Equipment",
            onSale: true,
            featured: false
        },
        {
            id: 2,
            baseCurrency: "USD",
            name: "Digital Thermometer",
            price: 24.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=300&h=300&fit=crop&crop=center",
            category: "Medical Equipment",
            onSale: false,
            featured: true
        },
        {
            id: 3,
            baseCurrency: "USD",
            name: "Blood Pressure Monitor",
            price: 65.99,
            originalPrice: 85.00,
            image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=300&h=300&fit=crop&crop=center",
            category: "Medical Equipment",
            onSale: true,
            featured: false
        },
        {
            id: 4,
            baseCurrency: "USD",
            name: "Pulse Oximeter",
            price: 35.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=300&h=300&fit=crop&crop=center",
            category: "Medical Equipment",
            onSale: false,
            featured: false
        },
        {
            id: 5,
            baseCurrency: "USD",
            name: "First Aid Kit",
            price: 45.99,
            originalPrice: 60.00,
            image: "https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=300&h=300&fit=crop&crop=center",
            category: "Emergency Care",
            onSale: true,
            featured: true
        },
        {
            id: 6,
            baseCurrency: "USD",
            name: "Medical Face Masks (50 pack)",
            price: 12.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=300&h=300&fit=crop&crop=center",
            category: "Protective Equipment",
            onSale: false,
            featured: false
        },
        {
            id: 7,
            baseCurrency: "USD",
            name: "Digital Scale",
            price: 55.99,
            originalPrice: 75.00,
            image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=300&h=300&fit=crop&crop=center",
            category: "Health Monitoring",
            onSale: true,
            featured: false
        },
        {
            id: 8,
            baseCurrency: "USD",
            name: "Glucose Meter Kit",
            price: 39.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=300&h=300&fit=crop&crop=center",
            category: "Health Monitoring",
            onSale: false,
            featured: false
        },
        {
            id: 9,
            baseCurrency: "USD",
            name: "Medical Gloves (100 pack)",
            price: 8.99,
            originalPrice: 12.00,
            image: "https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=300&h=300&fit=crop&crop=center",
            category: "Protective Equipment",
            onSale: true,
            featured: false
        },
        {
            id: 10,
            baseCurrency: "USD",
            name: "Hand Sanitizer (500ml)",
            price: 6.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=300&h=300&fit=crop&crop=center",
            category: "Hygiene",
            onSale: false,
            featured: true
        },
        {
            id: 11,
            baseCurrency: "USD",
            name: "Oxygen Saturation Monitor",
            price: 79.99,
            originalPrice: 99.00,
            image: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=300&h=300&fit=crop&crop=center",
            category: "Medical Equipment",
            onSale: true,
            featured: false
        },
        {
            id: 12,
            baseCurrency: "USD",
            name: "Medical Tape (10 rolls)",
            price: 15.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=300&h=300&fit=crop&crop=center",
            category: "Medical Supplies",
            onSale: false,
            featured: false
        },
        {
            id: 13,
            baseCurrency: "USD",
            name: "Infrared Thermometer",
            price: 49.99,
            originalPrice: 65.00,
            image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=300&h=300&fit=crop&crop=center",
            category: "Medical Equipment",
            onSale: true,
            featured: false
        },
        {
            id: 14,
            baseCurrency: "USD",
            name: "Wheelchair",
            price: 299.99,
            originalPrice: 399.00,
            image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=300&h=300&fit=crop&crop=center",
            category: "Mobility Aids",
            onSale: true,
            featured: true
        },
        {
            id: 15,
            baseCurrency: "USD",
            name: "Crutches (Pair)",
            price: 35.99,
            originalPrice: null,
            image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=300&h=300&fit=crop&crop=center",
            category: "Mobility Aids",
            onSale: false,
            featured: false
        },
        {
            id: 16,
            baseCurrency: "USD",
            name: "Nebulizer Machine",
            price: 89.99,
            originalPrice: 120.00,
            image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=300&h=300&fit=crop&crop=center",
            category: "Respiratory Care",
            onSale: true,
            featured: false
        }
    ]);

    const [sortBy, setSortBy] = useState('menu_order');

    // Update display prices when currency changes
    useEffect(() => {
        const updatePrices = async () => {
            const newPrices = {};
            for (const product of products) {
                const displayPrice = await getDisplayPrice(product.price, product.baseCurrency);
                const originalDisplayPrice = product.originalPrice ? 
                    await getDisplayPrice(product.originalPrice, product.baseCurrency) : null;
                newPrices[product.id] = {
                    price: displayPrice,
                    originalPrice: originalDisplayPrice
                };
            }
            setDisplayPrices(newPrices);
        };
        updatePrices();
    }, [selectedCurrency]);

    const handleImageError = (e, productId) => {
        const fallbackIndex = (productId - 1) % fallbackImages.length;
        e.target.src = fallbackImages[fallbackIndex];
        e.target.alt = `Medical equipment placeholder for product ${productId}`;
    };

    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortBy(value);
        
        const sortedProducts = [...products].sort((a, b) => {
            switch(value) {
                case 'price':
                    return a.price - b.price;
                case 'price-desc':
                    return b.price - a.price;
                case 'popularity':
                    return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
                case 'date':
                    return b.id - a.id; // Assuming higher ID = newer
                case 'rating':
                    // For demo purposes, use price as rating proxy
                    return b.price - a.price;
                default:
                    return a.id - b.id;
            }
        });
        
        setProducts(sortedProducts);
    };

    return (
        <>
            <PageSerch />
            <DynamicBreadcrumbs />

            <main className="dc-main dc-haslayout">
                <div className="container">
                    <div className="dc-twocolumns">
                        <div className="row">
                            <div className="col-12">
                                <div className="medical-shop-header">
                                    <h1 className="woocommerce-products-header__title page-title">🏥 Medical Equipment Shop</h1>
                                    <p>Professional medical supplies and equipment for healthcare providers</p>
                                </div>
                                <div className="woocommerce-notices-wrapper"></div>
                                <p className="woocommerce-result-count">Showing all {products.length} results</p>
                                <form className="woocommerce-ordering" method="get">
                                    <select 
                                        name="orderby" 
                                        className="orderby" 
                                        aria-label="Shop order"
                                        value={sortBy}
                                        onChange={handleSortChange}
                                    >
                                        <option value="menu_order">Default sorting</option>
                                        <option value="popularity">Sort by popularity</option>
                                        <option value="rating">Sort by average rating</option>
                                        <option value="date">Sort by latest</option>
                                        <option value="price">Sort by price: low to high</option>
                                        <option value="price-desc">Sort by price: high to low</option>
                                    </select>
                                    <input type="hidden" name="paged" value="1" />
                                </form>
                                <ul className="products columns-4">
                                    {products.map((product, index) => 
                                    (
                                        <li key={product.id} className={`product type-product post-${product.id} status-publish ${index === 0 ? 'first' : ''} ${index === products.length - 1 ? 'last' : ''} instock product_cat-${product.category.toLowerCase().replace(/\s+/g, '-')} has-post-thumbnail ${product.onSale ? 'sale' : ''} ${product.featured ? 'featured' : ''} shipping-taxable purchasable product-type-simple`}>
                                            <a href={`/product/${product.id}`} className="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                                                {product.onSale && <span className="onsale">Sale!</span>}
                                                <div className="image-container">
                                                    <img 
                                                        src={product.image} 
                                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" 
                                                        alt={product.name}
                                                        loading={index < 4 ? "eager" : "lazy"}
                                                        decoding="async"
                                                        onError={(e) => handleImageError(e, product.id)}
                                                    />
                                                </div>
                                                <h2 className="woocommerce-loop-product__title">{product.name}</h2>
                                            <span className="price">
                                                    {product.originalPrice ? (
                                                        <>
                                                            <del aria-hidden="true">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                                        <span className="woocommerce-Price-currencySymbol">{getCurrencySymbol(selectedCurrency)}</span>
                                                                        {displayPrices[product.id]?.originalPrice?.toFixed(2) || product.originalPrice.toFixed(2)}
                                                    </bdi>
                                                    </span>
                                                </del>
                                                <span className="screen-reader-text">Original price was: {getCurrencySymbol(selectedCurrency)}{displayPrices[product.id]?.originalPrice?.toFixed(2) || product.originalPrice.toFixed(2)}.</span>
                                                <ins aria-hidden="true">
                                                    <span className="woocommerce-Price-amount amount">
                                                                    <bdi>
                                                                        <span className="woocommerce-Price-currencySymbol">{getCurrencySymbol(selectedCurrency)}</span>
                                                                        {displayPrices[product.id]?.price?.toFixed(2) || product.price.toFixed(2)}
                                                                    </bdi>
                                                    </span>
                                                </ins>
                                                            <span className="screen-reader-text">Current price is: {getCurrencySymbol(selectedCurrency)}{displayPrices[product.id]?.price?.toFixed(2) || product.price.toFixed(2)}.</span>
                                                        </>
                                                    ) : (
                                                    <span className="woocommerce-Price-amount amount">
                                                            <bdi>
                                                                <span className="woocommerce-Price-currencySymbol">{getCurrencySymbol(selectedCurrency)}</span>
                                                                {displayPrices[product.id]?.price?.toFixed(2) || product.price.toFixed(2)}
                                                            </bdi>
                                                    </span>
                                                    )}
                                                </span>
                                            </a>
                                            <a 
                                                href={`?add-to-cart=${product.id}`} 
                                                aria-describedby={`woocommerce_loop_add_to_cart_link_describedby_${product.id}`}
                                                data-quantity="1" 
                                                className="button product_type_simple add_to_cart_button ajax_add_to_cart" 
                                                data-product_id={product.id} 
                                                data-product_sku={`meddy-${product.name.toLowerCase().replace(/\s+/g, '-')}`} 
                                                aria-label={`Add to cart: "${product.name}"`} 
                                                rel="nofollow" 
                                                data-success_message={`"${product.name}" has been added to your cart`}
                                            >
                                                Add to cart
                                            </a>
                                            <span id={`woocommerce_loop_add_to_cart_link_describedby_${product.id}`} className="screen-reader-text">
                                                This product can be added to your cart
                                            </span>
                                    </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>           
            </main>

        </>
    );
};

export default Shop;
